export const initialWorkplaceList = [];
